import { defineComponent as _defineComponent } from 'vue';
import { storeToRefs } from "pinia";
import { BNavItem } from "bootstrap-vue";
import Popper from "components/Popper/Popper.vue";
import { useRouter } from "vue-router/composables";
import { faBell } from "@fortawesome/free-solid-svg-icons";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { useNotificationsStore } from "@/stores/notificationsStore";
export default /*#__PURE__*/ _defineComponent({
    __name: 'NotificationsBell',
    props: {
        tooltipPlacement: {
            type: String,
            default: "right",
        },
    },
    setup(__props) {
        library.add(faBell);
        const router = useRouter();
        const { totalUnreadCount } = storeToRefs(useNotificationsStore());
        function onClick() {
            router.push("/user/notifications");
        }
        return { __sfc: true, router, totalUnreadCount, onClick, BNavItem, Popper, faBell, FontAwesomeIcon };
    }
});
